<template>
<div ref="element" class="ratio-img-container">
 
    <img style="display:none;" @load="imageLoaded" @error="imageError" :src="lazySrc">
    
    <div v-if="showBlur && !cover" class="poster-img-blur svgBlur" :style="computeBackgroundStyleBlur"></div>
    <div class="poster-img" :style="computeBackgroundStyle"></div>
    <img class="ratio-img" :src="ratioImgSrc">
    
    <svg class='hideSvgSoThatItSupportsFirefox'>
      <filter id='sharpBlur'>
        <feGaussianBlur stdDeviation='3'></feGaussianBlur>
        <feColorMatrix type='matrix' values='1 0 0 0 0, 0 1 0 0 0, 0 0 1 0 0, 0 0 0 9 0'></feColorMatrix>
        <feComposite in2='SourceGraphic' operator='in'></feComposite>
      </filter>
    </svg>
    
    <div class="icons-container"><slot name="icons"></slot></div>

    <spinner v-if="loading" class="spinner"/>
</div>
</template>

<script>
import Spinner from '../components/Spinner.vue';

export default {
  name: 'ratio-image',
  props:{
    src:{default:""},
    cover:{default:false}, // let blur the bg image
  },
  data(){
    return {
      backGroundUrl:"",
      ratioHeight:0,
      element:undefined,
      lazySrc:undefined,
      observer:undefined,
      loading:false,
      showBlur:false,

    }
  },
  components: {
    Spinner,
  },
  computed:{
    ratioImgSrc:function(){
      return require('../assets/16x9.png');
    },
    computeBackgroundStyleBlur:function(){
      return {backgroundImage:'url('+this.backGroundUrl+')',backgroundSize:'cover'}
    },
    computeBackgroundStyle:function(){
      return {backgroundImage:'url('+this.backGroundUrl+')',backgroundSize:this.cover ? 'cover':'contain'}
    },
    computeRatioHeight:function(){
      return {height:this.ratioHeight+"px"}
    }
  },
  methods:{
    imageLoaded(event){
      this.backGroundUrl=event.target.src;
      this.loading=false;
      this.showBlur=true;
    },
    imageError(){
      this.backGroundUrl=require('../assets/thumb_404.png');
      this.backgroundSize="contain";
      this.loading=false;
    },
    lazyLoad(){
      
        this.lazySrc=this.src;
        this.loading=true;

        this.removeListeners();
      
    },
    addListeners(){
      //eventBus.$on("SCROLL",this.lazyLoad);

      const options = {
        root: null, // The document viewport (default)
        rootMargin: '0px', // No offset from the root element (default)
        threshold: .001, // Full intersection into the root element
      };

      this.observer = new IntersectionObserver( (el) => {
        
      if(!el[0].intersectionRatio){return;}
        if (el[0].intersectionRatio >= options.threshold) {
        
          this.lazyLoad();
          this.observer.disconnect();
        }
      }, options);
      
      this.observer.observe(this.element);
    },
    removeListeners(){
      
      this.observer.disconnect();
    }
  },
  beforeDestroy(){
    this.removeListeners();
  },
  mounted:function(){
    this.element=this.$refs['element'];
    this.addListeners();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.ratio-img-container{
  
  position:relative;
  overflow:hidden;
  display:flex;
  justify-content: center;
  align-items: center;
  width:100%;
  
}

.icons-container{
  position:absolute;
  left:5px;
  bottom:5px;
}

.poster-img-blur{
  display:block;
  position:absolute;
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-position: center;
  background-color:#D9D9D9;
  /*filter: blur(8px);
  -webkit-filter: blur(8px);*/
  background-size:cover;
  transform: scale(1.5);
}
.poster-img{
  display:block;
  position:absolute;
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-position: center;
  /*background-size:contain;*/
}
.ratio-img{
  display:block;
  position:relative;
  width: 100%;
  height: 100%; /* was auto */
}

.svgBlur { 
  filter: blur(1px);
  opacity:.8;
}

.hideSvgSoThatItSupportsFirefox {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
  display:none;
}
.spinner{
  position: absolute;
}
</style>
